import device from '../helpers/device'
import refs from '../helpers/refs'
import site from '../helpers/site'
import { debounce } from '../helpers/lodash-custom'
import priceHelper from '../helpers/price'

// Have the keys used here match this.blogTypes
const BLOG_HANDLES = {
  masterbuilt: {
    recipe: 'recipes',
    blog: 'master-it-blog'
  },
  kamadojoe: {
    recipe: 'recipes',
    blog: 'kamado-joe-blog'
  },
  chargriller: {
    recipe: 'recipes',
    grillingTips: 'tips-and-care'
  }
}

class CHeader {
  constructor (el) {
    this.header = el
    this.$refs = refs(this.header)
    this.mobileNavOpen = false
    // When dynamically setting bg color - use right bg color based on site
    // TODO: Switch to toggling classes and have PostCSS handle site diff
    this.site = site()
    this.primaryBgColor = this.site === 'masterbuilt' ? 'grey-700' : 'white'
    this.secondaryBgColor = this.site === 'masterbuilt' ? 'grey-900' : 'white'

    this.defaultQueryText = 'grilling'
    if (this.site === 'masterbuilt') {
      this.defaultQueryText = 'gravity'
    } else if (this.site === 'kamadojoe') {
      this.defaultQueryText = 'big joe'
    } else if (this.site === 'chargriller') {
      this.defaultQueryText = 'akorn'
    }

    // Predictive search
    this.queryText = null
    // Predictive search API responses from Shopify
    // Results are very limited if all types are queried, so products, articles, and pages are queried separately. "All" is the combination
    this.results = {
      all: null,
      products: null,
      articles: null,
      pages: null
    }
    // Which content types should show in search results? Shopify calls these "resource types"
    this.resourceTypes = {
      product: true,
      collection: false,
      page: false,
      article: false,
      query: false
    }
    // Articles of which blog should show in search results?
    this.blogFilter = {
      recipe: false,
      grillingTips: false,
      blog: false
    }
    // Keep track of how many search results match each filter option
    this.filterCounts = {
      product: 0,
      recipe: 0,
      // grillingTips: 0,
      page: 0
    }

    // Mobile buttons
    this.buttonProducts = document.body.querySelector('[ref="buttonProducts"]')
    this.buttonRecipes = document.body.querySelector('[ref="buttonRecipes"]')
    // this.buttonGrillingTips = document.body.querySelector('[ref="buttonGrillingTips"]')
    this.buttonSupportPages = document.body.querySelector('[ref="buttonSupportPages"]')
    this.buttonAll = document.body.querySelector('[ref="buttonAll"]')

    // Desktop buttons
    this.radioAll = document.body.querySelector('[ref="radio-all"]')
    this.radioProducts = document.body.querySelector('[ref="radio-products"]')
    this.radioRecipes = document.body.querySelector('[ref="radio-recipes"]')
    // this.radioGrillingTips = document.body.querySelector('[ref="radio-grilling-tips"]')
    this.radioSupportPages = document.body.querySelector('[ref="radio-support-pages"]')

    if (device.isDesktop()) {
      this.searchInput = document.querySelector('[ref="searchFormInput"]')
      this.searchResultsElem = document.querySelector('[ref="searchResults"]')
    } else {
      this.searchInput = document.querySelector('[ref="searchFormInputMobile"]')
      this.searchResultsElem = document.querySelector('[ref="searchResultsMobile"]')
    }

    this.init()

    // Only use a transparent nav with certain mastheads
    const compatibleMastheads = [
      '.c-masthead-explore',
      '.c-masthead-feature',
      '.c-masthead-collection'
    ]
    if (
      compatibleMastheads.reduce(
        (prev, curr) => prev + document.querySelectorAll(curr).length,
        0
      ) > 0
    ) {
      this.transparentNav = true
      // Make nav opaque at 150px scrolled down
      this.navOpaqueAt = 150

      this.initTransparentNav()
    } else {
      // Masthead is not compatible with transparent nav - set background
      if (this.site === 'masterbuilt') {
        this.header.classList.add(`xl:bg-${this.primaryBgColor}`)
      }
      this.$refs.mainNav.classList.add(`xl:bg-${this.primaryBgColor}`)
    }
  }

  init () {
    if (this.$refs.searchButton) {
      this.$refs.searchButton.addEventListener('click', (e) => {
        // Handle iOS Safari's buggy click event behavior
        e.preventDefault()
        e.stopPropagation()

        this.openSearchForm()
      })
    } else {
      console.warn('init() - No search button found')
    }

    if (this.$refs.searchButtonMobile) {
      this.$refs.searchButtonMobile.addEventListener('click', (e) => {
        e.preventDefault()
        this.openSearchFormMobile()
      })
    } else {
      console.warn('init() - No mobile search button found')
    }

    if (this.$refs.searchForm) {
      this.$refs.searchFormClose.addEventListener('click', (e) => {
        e.preventDefault()
        this.closeSearchForm()
      })
    } else {
      console.warn('init() - No search form found')
    }

    if (this.$refs.searchFormMobile) {
      this.$refs.searchFormCloseMobile.addEventListener('click', (e) => {
        e.preventDefault()
        this.closeSearchFormMobile()
        this.hideSearchResultsPanel()
      })
    } else {
      console.warn('init() - No mobile search form found')
    }

    this.$refs.menuItems.forEach((item) => {
      if (!item || !item.dataset.menu) {
        console.warn('init() - No menu item found')
        return
      }

      // Check there's a dropdown element that exists
      // (nav items that don't have dropdown content, won't have a dropdown element)
      if (this.$refs.menus.find(dropdownMenu => dropdownMenu.dataset.menu === item.dataset.menu)) {
        item.addEventListener('mouseenter', () => {
          this.openMenu(item.getAttribute('data-menu'))
        })
      } else {
        // Menu item without dropdown, close any dropdowns already open to avoid confusion
        item.addEventListener('mouseenter', () => {
          this.closeAllMenus()
        })
      }
    })

    if (this.header) {
      this.header.addEventListener('mouseleave', () => {
        this.closeAllMenus()
      })
    } else {
      console.warn('init() - No header found')
    }

    this.$refs.menuButton.addEventListener('click', (e) => {
      // Handle iOS Safari's buggy click event behavior
      e.preventDefault()
      e.stopPropagation()

      if (this.mobileNavOpen) {
        this.closeMobileNav()
      } else {
        this.openMobileNav()
      }
    })

    if (this.$refs.toggleCart) {
      this.$refs.toggleCart.addEventListener('click', (e) => {
        // 8/19/2024 - Sarah wants the slide out cart to open every time, every device
        // removing conditional because behavior should be the same
        document.dispatchEvent(new CustomEvent('cart:toggle'))
        /*
        if (device.isDesktop()) {
          document.dispatchEvent(new CustomEvent('cart:toggle'))
        } else {
          window.location.href = `${window.localeInformation.rootUrl}/cart`
        }
        */
      })
    } else {
      console.warn('init() - No cart toggle button found')
    }

    document.addEventListener('cart:updated', (e) => {
      const itemCount = e.detail.item_count

      // Hide or unhide cart icon depending on item count
      if (
        itemCount > 0 &&
        this.$refs.slideOutCartIcon.classList.contains('hidden')
      ) {
        this.$refs.slideOutCartIcon.classList.remove('hidden')
      } else if (itemCount === 0) {
        this.$refs.slideOutCartIcon.classList.add('hidden')
      }

      // Set cart icon count
      this.$refs.slideOutCartIcon.innerText = itemCount
    })

    // Recipes submenu - right now char-griller only
    if (this.$refs.recipesMenuButton) {
      this.setupRecipesSubmenu()
    }

    // Predictive search
    this.initPredictiveSearch()
  }

  setSearchButtonActive (activeButton) {
    if (device.isMobile()) {
      if (this.buttonAll) {
        this.buttonAll.classList.remove('active')
      }
      this.buttonProducts.classList.remove('active')
      this.buttonRecipes.classList.remove('active')
      // if (this.buttonGrillingTips) {
      //   this.buttonGrillingTips.classList.remove('active')
      // }
      if (this.buttonSupportPages) {
        this.buttonSupportPages.classList.remove('active')
      }

      activeButton.classList.add('active')
    }
  }

  initPredictiveSearch () {
    const runSearch = debounce((...args) => this.updateSearchResults.apply(this, args), 300)
    // Stagger the announcement of search results to avoid spamming screen readers
    const runSearchAnnounce = debounce((...args) => this.announceSearchResults.apply(this, args), 1000)

    // all
    window.addEventListener('search:show-all', () => {
      this.resourceTypes = {
        product: true,
        page: true,
        article: true
      }
      this.blogFilter = {
        recipe: true,
        grillingTips: true,
        blog: true
      }

      this.setSearchButtonActive(this.buttonAll)
      // Re-run search for all
      this.updateSearchResults(this.searchInput.value, this.searchResultsElem, false)
      this.announceSearchResults()
    })
    // products
    window.addEventListener('search:show-products', () => {
      this.resourceTypes = {
        product: true,
        page: false,
        article: false
      }

      this.setSearchButtonActive(this.buttonProducts)
      // Re-run search for products instead of articles
      this.updateSearchResults(this.searchInput.value, this.searchResultsElem, false)
      this.announceSearchResults()
    })
    // recipes
    window.addEventListener('search:show-recipes', () => {
      this.resourceTypes = {
        article: true,
        product: false,
        page: false
      }
      this.blogFilter = {
        recipe: true,
        grillingTips: true,
        blog: true
      }

      this.setSearchButtonActive(this.buttonRecipes)
      // Re-run search for recipes instead of products
      this.updateSearchResults(this.searchInput.value, this.searchResultsElem, false)
      this.announceSearchResults()
    })
    // grilling tips
    // window.addEventListener('search:show-grilling-tips', () => {
    //   this.resourceTypes = {
    //     article: true,
    //     product: false,
    //     page: false
    //   }
    //   this.blogFilter = {
    //     recipe: false,
    //     grillingTips: true
    //   }

    //   this.setSearchButtonActive(this.buttonGrillingTips)
    //   // Re-run search for all
    //   this.updateSearchResults(this.searchInput.value, this.searchResultsElem, false)
    //   this.announceSearchResults()
    // })
    // support pages
    window.addEventListener('search:show-support-pages', () => {
      this.resourceTypes = {
        page: true,
        product: false,
        article: false
      }

      this.setSearchButtonActive(this.buttonSupportPages)
      // Re-run search for all
      this.updateSearchResults(this.searchInput.value, this.searchResultsElem, false)
      this.announceSearchResults()
    })
    // hide results
    window.addEventListener('search:hide-results', () => {
      this.hideSearchResultsPanel()
    })

    // When the user types in the search box, show auto-complete search results using Shopify's Predictive Search API
    this.searchInput.addEventListener('keyup', (event) => {
      if (event.keyCode === 13) {
        // If the user presses enter, submit the form
        event.preventDefault()
        this.searchInput.form.submit()
      } else if (event.keyCode === 27) {
        // If the user presses escape, close the search results panel
        this.hideSearchResultsPanel()
      } else if (this.searchInput.value !== '' && this.searchInput.value !== this.queryText) {
        // Don't rerun the search if the query text hasn't changed
        // On first run, show the search results container
        if (this.queryText == null) {
          this.showSearchResultsPanel()
        }

        // throttle used to prevent spamming the Predictive Search API
        runSearch(this.searchInput.value, this.searchResultsElem)
        runSearchAnnounce()
      }
    })

    // On "view all" click, navigate to search results page
    // Not used on intl so test for element first
    if (document.body.querySelector('[ref="viewAllResultsButton"]')) {
      const url = `${window.localeInformation.rootUrl}/search?q=${this.searchInput.value}&type=${this.resourceTypes}`
      document.body.querySelectorAll('[ref="viewAllResultsButton"]').forEach((button) => {
        if (button) {
          button.addEventListener('click', (event) => {
            window.location.href = url
          })
        } else {
          console.warn('initPredictiveSearch() - No "view all" button found')
        }
      })
    }

    // Mobile filtering
    const mobileNavFilterButton = document.querySelector('[ref="mobileNavFilterButton"]')
    const searchFiltersMobile = document.querySelector('[ref="searchFiltersMobile"]')

    if (mobileNavFilterButton && searchFiltersMobile) {
      mobileNavFilterButton.addEventListener('click', (e) => {
        e.preventDefault()

        if (searchFiltersMobile.classList.contains('hidden')) {
          searchFiltersMobile.classList.remove('hidden')
          searchFiltersMobile.classList.add('flex')
        } else {
          searchFiltersMobile.classList.add('hidden')
          searchFiltersMobile.classList.remove('flex')
        }
      })
    } else {
      console.warn('initPredictiveSearch() - No mobile filter button or search filters found')
    }
  }

  initTransparentNav () {
    // Check every 500ms if page is scroll to top, change to transparent nav if so
    if (device.isDesktop) {
      const checkNav = () => {
        if (window.scrollY >= this.navOpaqueAt && this.transparentNav) {
          this.transparentNav = false
          if (this.site === 'masterbuilt') {
            this.header.classList.add(`xl:bg-${this.primaryBgColor}`)
          }
          this.$refs.mainNav.classList.add(`xl:bg-${this.primaryBgColor}`)
          document.querySelectorAll('.c-header__menu').forEach((menu) => {
            menu.classList.add(`xl:bg-${this.secondaryBgColor}`)
          })
        } else if (window.scrollY < this.navOpaqueAt && !this.transparentNav) {
          this.transparentNav = true
          if (this.site === 'masterbuilt') {
            this.header.classList.remove(`xl:bg-${this.primaryBgColor}`)
          }
          this.$refs.mainNav.classList.remove(`xl:bg-${this.primaryBgColor}`)
          document.querySelectorAll('.c-header__menu').forEach((menu) => {
            menu.classList.remove(`xl:bg-${this.secondaryBgColor}`)
          })
        }
      }
      setInterval(checkNav, 500)
    }
  }

  openMobileNav () {
    this.mobileNavOpen = true
    this.$refs.menuButtonIconMenu.classList.remove(
      'c-header__mobile-menu-button--active'
    )
    this.$refs.menuButtonIconClose.classList.add(
      'c-header__mobile-menu-button--active'
    )
    const event = new CustomEvent('mobileMenu:open')
    document.dispatchEvent(event)
  }

  closeMobileNav () {
    this.mobileNavOpen = false
    this.$refs.menuButtonIconMenu.classList.add(
      'c-header__mobile-menu-button--active'
    )
    this.$refs.menuButtonIconClose.classList.remove(
      'c-header__mobile-menu-button--active'
    )
    const event = new CustomEvent('mobileMenu:close')
    document.dispatchEvent(event)
  }

  openMenu (handle) {
    this.$refs.menus.forEach((menu) => {
      if (menu.getAttribute('data-menu') === handle) {
        menu.classList.add('c-header__menu--active')
      } else {
        menu.classList.remove('c-header__menu--active')
      }
    })

    this.$refs.menuItems.forEach((item) => {
      if (item.getAttribute('data-menu') === handle) {
        item.classList.add('c-header__nav-item--active')
      } else {
        item.classList.remove('c-header__nav-item--active')
      }
    })
  }

  closeMenu (handle) {
    this.$refs.menus.forEach((menu) => {
      if (menu.getAttribute('data-menu') === handle) {
        menu.classList.remove('c-header__menu--active')
      }
    })

    this.$refs.menuItems.forEach((item) => {
      if (item.getAttribute('data-menu') === handle) {
        item.classList.remove('c-header__nav-item--active')
      }
    })
  }

  closeAllMenus () {
    this.$refs.menus.forEach((menu) => {
      menu.classList.remove('c-header__menu--active')
    })

    this.$refs.menuItems.forEach((item) => {
      item.classList.remove('c-header__nav-item--active')
    })
  }

  openSearchForm () {
    this.closeAllMenus()
    this.$refs.searchForm.classList.add('c-header__search-form--active')
    this.$refs.searchFormInput.focus()

    // Hide main menu items from accessibility tree
    // If check added here because this ref has only been added on Char-Griller so far
    if (this.$refs.mainNavItems) {
      this.$refs.mainNavItems.setAttribute('aria-hidden', 'true')
    }
    this.$refs.searchButton.setAttribute('aria-hidden', 'true')
  }

  closeSearchForm () {
    this.$refs.searchForm.classList.remove('c-header__search-form--active')

    // Show main menu items from accessibility tree again
    // If check added here because this ref has only been added on Char-Griller so far
    if (this.$refs.mainNavItems) {
      this.$refs.mainNavItems.setAttribute('aria-hidden', 'false')
    }
    this.$refs.searchButton.setAttribute('aria-hidden', 'false')
  }

  openSearchFormMobile () {
    this.closeAllMenus()
    this.$refs.searchFormMobile.classList.add(
      'c-header__search-form-mobile--active'
    )
    this.$refs.searchFormInputMobile.focus()
  }

  closeSearchFormMobile () {
    this.$refs.searchFormMobile.classList.remove(
      'c-header__search-form-mobile--active'
    )
  }

  // * Note: Currently this is only used on the Char-Griller site
  // Allows the "Recipes" link under "Explore" to open a completely new dropdown menu for "Recipes"
  // Have the "Back to Explore" button close the "Recipes" dropdown and open the "Explore" dropdown
  setupRecipesSubmenu () {
    // recipe menu data-menu: Recipes
    // explore menu data-menu: Explore
    // back button ref: backToExploreButton
    // recipe menu button ref: recipesMenuButton

    // On "Recipes" click, open the "Recipes" dropdown
    if (this.$refs.recipesMenuButton) {
      this.$refs.recipesMenuButton.addEventListener('click', (event) => {
        event.preventDefault()

        this.openMenu('recipes')
        this.closeMenu('explore')
      })
    } else {
      console.warn('setupRecipesSubmenu() - No "Recipes" menu button found')
    }

    // On "Back to Explore" click, close the "Recipes" dropdown and open the "Explore" dropdown
    if (this.$refs.backToExploreButton) {
      this.$refs.backToExploreButton.addEventListener('click', (event) => {
        event.preventDefault()

        this.openMenu('explore')
        this.closeMenu('recipes')
      })
    } else {
      console.warn('setupRecipesSubmenu() - No "Back to Explore" button found')
    }
  }

  // --- Predictive Search ----------------------------------------------------------------
  // Get Product image at specific size
  // Cherry-picked from Shopify's "theme-scripts": https://github.com/Shopify/theme-scripts/blob/master/packages/theme-images/images.js
  getImageAtSize (imageURL, size) {
    const match = imageURL.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i)

    if (match) {
      const prefix = imageURL.split(match[0])
      const suffix = match[0]

      // '_crop_center' added to force "size" to be the exact size of the image, otherwise it's "contained" in "size"
      return (`${prefix[0]}_${size}${suffix}_crop_center`).replace(/http(s)?:/, '')
    } else {
      console.warn('getProductImage(url) - Could not parse image url', imageURL)
      return imageURL
    }
  }

  // This renders the list of search results
  getResultsHTML (results) {
    const thumbnailSize = { x: 96, y: 72 }
    const filteredResults = []

    // Show products
    if (this.resourceTypes.product) {
      filteredResults.push(...results.products)
    }

    // Only show articles if they're not filtered out, and if they're on a filtered blog type
    if (this.resourceTypes.article) {
      filteredResults.push(...results.articles.filter((article) => {
        // Iterate through the blogs for this site, check if the article is on a filtered blog type
        for (const [filterKey, handle] of Object.entries(BLOG_HANDLES[this.site])) {
          if (article.url.startsWith(`/blogs/${handle}`) && this.blogFilter[filterKey]) {
            return true
          }
        }

        return false
      }))
    }

    // Show pages
    if (this.resourceTypes.page) {
      filteredResults.push(...results.pages)
    }

    return filteredResults.map((result) => {
      const imageURL = (result.featured_image ? result.featured_image.url : result.image) || ''
      const imageThumbnail = imageURL ? this.getImageAtSize(imageURL, `${thumbnailSize.x}x${thumbnailSize.y}`) : ''
      const imageAlt = result.featured_image ? result.featured_image.alt : result.title

      if (result.url.includes('/products/')) {
        return this.getProductHTML(result, imageThumbnail, thumbnailSize, imageAlt)
      } else if (result.url.includes('/blogs/')) {
        return this.getArticleHTML(result, imageThumbnail, thumbnailSize, imageAlt)
      } else {
        return this.getPageHTML(result, imageThumbnail, thumbnailSize, imageAlt)
      }
    }).join('\n')
  }

  getProductHTML (result, imageThumbnail, thumbnailSize, imageAlt) {
    return `<div class="c-header__search-result">
      <a
        class="flex flex-row group w-full py-2 px-4 border-b border-grey-200 hover:bg-grey-100 hover:border-brand focus:bg-grey-100 focus:border-brand"
        href="${window.localeInformation.rootUrl}${result.url}">
        ${imageThumbnail
          ? `<img
            class="c-header__search-result-image block object-contain text-xs"
            style="height: ${thumbnailSize.y}px;"
            src="${imageThumbnail}"
            alt="${imageAlt}"
            width="${thumbnailSize.x}"
            height="${thumbnailSize.y}">`
            : ''
        }
        <div class="flex flex-col py-2 mx-4">
          <div class="c-header__search-result-title font-bold group-hover:underline">${result.title}</div>
          <div class="c-header__search-result-price mt-1">${priceHelper.formatPrice(result.price * 100)}</div>
        </div>
      </a>
    </div>`
  }

  getArticleHTML (result, imageThumbnail, thumbnailSize, imageAlt) {
    let skill = ''
    let prepTime = ''
    let cookTime = ''
    let ariaLabel = ''
    const isRecipe = result.url.includes('/blogs/recipes/')

    // On recipes, show cook time and skill level
    if (isRecipe) {
      // cannot assume cook-time and skill-level tags exist, so test before replacing
      // Cook time
      const cookTimeTag = result.tags ? result.tags.find(tag => tag.includes('cook-time-')) : null
      if (cookTimeTag) {
        cookTime = cookTimeTag.replace('cook-time-', '')
      }

      // prep time
      const prepTimeTag = result.tags ? result.tags.find(tag => tag.includes('prep-time-')) : null
      if (prepTimeTag) {
        prepTime = prepTimeTag.replace('prep-time-', '')
      }

      // Skill level
      const skillTag = result.tags.find(tag => tag.includes('skill-level-'))
      if (skillTag) {
        skill = parseInt(skillTag.replace('skill-level-', ''))
        const skillLevelNames = ['Beginner', 'Intermediate', 'Advanced', 'Master']
        ariaLabel = `Skill Level: ${skillLevelNames[skill]}`
      }
    }
    // link to default image is subject to change...need a more dynamic way to link to default image per site
    return `<div class="c-header__search-result">
      <a
        class="flex flex-row group w-full py-2 px-4 border-b border-grey-200 hover:bg-grey-100 hover:border-brand focus:bg-grey-100 focus:border-brand"
        href="${window.localeInformation.rootUrl}${result.url}">
        ${imageThumbnail
          ? `<img
            class="c-header__search-result-image block object-cover"
            style="height: ${thumbnailSize.y}px;"
            src="${imageThumbnail}"
            alt="${imageAlt}"
            width="${thumbnailSize.x}"
            height="${thumbnailSize.y}">`
            : `
            <img
              class="c-header__search-result-image block object-cover"
              style="height: 72px;"
              src="https://www.chargriller.com/cdn/shop/t/55/assets/CG_Website_BlogHeaders_CalibrateThermometer_1920x1080.jpg?v=127060347600108137531702579521"
              alt="Placeholder image"
              width="96"
              height="72">
            `
        }
        <div class="flex flex-col justify-center ml-4">
          <div class="c-header__search-result-title font-bold text-h6 group-hover:underline">${result.title}</div>
          <div class="c-header__search-result-details mt-1">
            ${isRecipe && (prepTime || cookTime || skill)
              ? `
              <div class="mt-2 flex flex-col md:flex-row items-start md:items-center ">
                ${prepTime
                  ? `
                    <div class="font-bold text-sm text-brand-black uppercase whitespace-nowrap">
                      Prep Time: ${prepTime}
                    </div>
                  `
                  : ''
                }
                ${prepTime && cookTime ? '<div class="c-block-recipe-feature__spacer bg-brand-black mx-4"></div>' : ''}
                ${cookTime
                  ? `
                    <div class="font-bold text-sm text-brand-black uppercase whitespace-nowrap">
                      Cook Time: ${cookTime}
                    </div>
                  `
                  : ''
                }
                ${cookTime && skill ? '<div class="c-block-recipe-feature__spacer bg-brand-black mx-4"></div>' : ''}
                ${skill
                  ? `
                    <div
                      class="font-bold text-sm text-brand-black uppercase flex items-center"
                      aria-label="${encodeURI(ariaLabel)}">
                      Skill:
                      ${[0, 1, 2, 3].map(level => level < skill
                        ? `<span class="inline-block w-3 ml-1" aria-hidden="true">
                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="a-svg " role="img" width="24px" height="24px" viewBox="0 0 14 16"><path xmlns="http://www.w3.org/2000/svg" id="Vector" d="M0.855109 8.7796C2.59327 10.5808 4.91207 8.2968 2.98408 6.82239C1.75583 5.88278 -1.57907 2.79655 0.88488 0C3.01385 4.03327 7.59561 3.33135 11.165 5.26628C14.0346 6.81868 14.8721 9.49638 12.9999 11.955C12.9999 11.8733 12.9888 11.8027 12.985 11.7247C12.9813 11.7247 12.9813 11.7173 12.985 11.7061C12.8399 9.22898 10.1377 9.56695 10.1377 9.56695C12.2072 10.5251 10.402 12.3375 9.58315 10.514C9.00996 9.24013 7.68867 8.49364 6.48274 8.18538C8.46284 10.3989 4.96418 14.0013 9.98886 15.4497C8.48518 16.2965 5.74207 16.0662 4.91579 15.4312C5.38848 14.7775 5.0535 14.0756 4.28305 13.9456C2.47417 13.6374 0.363808 12.5492 0.855109 8.7796Z" fill="#D9121F"></path></svg>
                        </span>`
                        : `<span class="inline-block w-3 ml-1" aria-hidden="true">
                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="a-svg " role="img" width="24px" height="24px" viewBox="0 0 14 16"><path xmlns="http://www.w3.org/2000/svg" id="Vector" d="M0.855109 8.7796C2.59327 10.5808 4.91207 8.2968 2.98408 6.82239C1.75583 5.88278 -1.57907 2.79655 0.88488 0C3.01385 4.03327 7.59561 3.33135 11.165 5.26628C14.0346 6.81868 14.8721 9.49638 12.9999 11.955C12.9999 11.8733 12.9888 11.8027 12.985 11.7247C12.9813 11.7247 12.9813 11.7173 12.985 11.7061C12.8399 9.22898 10.1377 9.56695 10.1377 9.56695C12.2072 10.5251 10.402 12.3375 9.58315 10.514C9.00996 9.24013 7.68867 8.49364 6.48274 8.18538C8.46284 10.3989 4.96418 14.0013 9.98886 15.4497C8.48518 16.2965 5.74207 16.0662 4.91579 15.4312C5.38848 14.7775 5.0535 14.0756 4.28305 13.9456C2.47417 13.6374 0.363808 12.5492 0.855109 8.7796Z" fill="#A8A8A8"></path></svg>
                          </span>`).join('')
                      }
                    </div>
                  `
                  : ''
                }
              </div>
            `
              : ''
            }
          </div>
        </div>
      </a>
    </div>`
  }

  getPageHTML (result, imageThumbnail, thumbnailSize, imageAlt) {
    return `<div class="c-header__search-result">
      <a
        class="flex flex-row group w-full border-b border-grey-200 hover:bg-grey-100 hover:border-brand focus:bg-grey-100 focus:border-brand"
        href="${window.localeInformation.rootUrl}${result.url}">
        ${imageThumbnail
          ? `<img
            class="c-header__search-result-image block object-contain text-xs"
            style="height: ${thumbnailSize.y}px;"
            src="${imageThumbnail}"
            alt="${imageAlt}"
            width="${thumbnailSize.x}"
            height="${thumbnailSize.y}">`
            : ''
        }
        <div class="flex flex-col py-2 px-4">
          <div class="c-header__search-result-title font-bold text-h6 group-hover:underline">${result.title}</div>
        </div>
      </a>
    </div>`
  }

  // Shopify Predictive Search
  // Implements: https://shopify.dev/api/ajax/reference/predictive-search
  async getPredictedResults (queryText = this.defaultQueryText,
    resourceTypes = {
      product: true,
      collection: false,
      page: true,
      article: true,
      query: false
    },
    searchableContent = {
      title: true,
      tag: true,
      body: true
    }) {
    const substitutions = {
      masterbuilt: {
        // Replace "big joe" with "gravity" on masterbuilt
        'big joe': 'gravity'
      },
      kamadojoe: { },
      chargriller: { }
    }

    if (substitutions[this.site] && substitutions[this.site][queryText]) {
      queryText = substitutions[this.site][queryText]
    }

    // If resource type includes pages, forcably search page content
    if (resourceTypes.page) {
      searchableContent.body = true
    }

    // Debug - On Storybook, force localhost:9292
    let searchDomain = ''
    if (window.location.host.includes('6006')) {
      if (window.location.host.includes('localhost')) {
        searchDomain = 'http://localhost:9292'
      } else if (window.location.host.includes('127.0.0.1')) {
        searchDomain = 'http://127.0.0.1:9292'
      }
    }

    const resourceTypeString = Object.keys(resourceTypes).reduce((prev, curr, index) => {
      if (resourceTypes[curr]) {
        return `${prev}${curr},`
      }

      return prev
    }, '').slice(0, -1)

    const resourceFieldString = Object.keys(searchableContent).reduce((prev, curr, index) => {
      if (searchableContent[curr]) {
        return `${prev}${curr},`
      }

      return prev
    }, '').slice(0, -1)

    return await (new Promise((resolve, reject) => {
      // If check added here because this ref has only been added on Char-Griller so far
      if (this.$refs.pendingText) {
        this.$refs.pendingText.classList.remove('hidden')
      }

      fetch(`${searchDomain}/search/suggest.json?q=${queryText}&resources[type]=${resourceTypeString}&resources[options][fields]=${resourceFieldString},variants.sku&resources[limit_scope]=each`).then(function (response) {
        return response.json()
      }).then(function (json) {
        if (json.status) {
          // Server error
          switch (json.status) {
            case 422:
              reject(new Error('Invalid query', json.description))
              break
            case 404:
              reject(new Error('not found'))
              break
            default:
              reject(new Error('unknown error'))
          }
        } else {
          const results = json.resources.results

          if ((resourceTypes.product && results.products && results.products.length > 0) ||
              (resourceTypes.article && results.articles && results.articles.length > 0) ||
              (resourceTypes.page && results.pages && results.pages.length > 0)
          ) {
            resolve({
              products: results.products || [],
              articles: results.articles || [],
              pages: results.pages || []
            })
          } else {
            resolve({
              products: [],
              articles: [],
              pages: []
            })
          }
        }
      }).catch(reject)
        .finally(() => {
          // If check added here because this ref has only been added on Char-Griller so far
          if (this.$refs.pendingText) {
            this.$refs.pendingText.classList.add('hidden')
          }
        })
    }))
  }

  formatCount (count) {
    // if the count is 10 or more, return {count}+ because predictive search is limited to 10 results
    if (count && count > 9) {
      return `${count}+`
    }

    return count
  }

  updateSearchFilterCounts ({
    productResults = [],
    articleResults = [],
    pageResults = []
  }) {
    const productCount = productResults.products?.length ?? 0
    const totalArticleCount = articleResults.articles?.length ?? 0
    const supportPagesCount = pageResults.pages?.length ?? 0
    // let recipeCount = 0
    // let grillingTipsCount = 0

    // if (this.site === 'chargriller' && articleResults.articles && articleResults.articles.length > 0) {
    //   // Count recipes
    //   recipeCount = articleResults.articles.filter(article => article.url.includes('/blogs/recipes/')).length
    //   // Count grilling tips
    //   grillingTipsCount = articleResults.articles.filter(article => article.url.includes('/blogs/tips-and-care/')).length
    // }

    // Update filter counts
    if (device.isMobile()) {
      this.buttonProducts.innerText = `Products (${this.formatCount(productCount)})`
      this.buttonRecipes.innerText = `Recipes and Posts (${this.formatCount(totalArticleCount)})`

      // if (this.site === 'chargriller') {
      this.buttonAll.innerText = `All (${this.formatCount(productCount + totalArticleCount + supportPagesCount)})`
      // this.buttonGrillingTips.innerText = `Grilling Tips (${this.formatCount(grillingTipsCount)})`
      this.buttonSupportPages.innerText = `Support Pages (${this.formatCount(supportPagesCount)})`
      // }
    } else {
      this.radioProducts.nextElementSibling.innerText = `Products (${this.formatCount(productCount)})`
      this.radioRecipes.nextElementSibling.innerText = `Recipes and Posts (${this.formatCount(totalArticleCount)})`

      // if (this.site === 'chargriller') {
      this.radioAll.nextElementSibling.innerText = `All (${this.formatCount(productCount + totalArticleCount + supportPagesCount)})`
      // this.radioGrillingTips.nextElementSibling.innerText = `Grilling Tips (${this.formatCount(grillingTipsCount)})`
      this.radioSupportPages.nextElementSibling.innerText = `Support Pages (${this.formatCount(supportPagesCount)})`
      // }
    }

    // Update counts object
    this.filterCounts = {
      product: productCount,
      recipe: totalArticleCount,
      // grillingTips: grillingTipsCount,
      pages: supportPagesCount
    }
  }

  announceSearchResults () {
    // Update aria labels to announce the new counts
    // This allows us to quickly/clearly announce how many results there are when search results change
    const categories = []
    if (this.filterCounts.product > 0) { categories.push(`${this.filterCounts.product} products`) }
    if (this.filterCounts.recipe > 0) { categories.push(`${this.filterCounts.recipe} recipes`) }
    // if (this.filterCounts.grillingTips > 0) { categories.push(`${this.filterCounts.grillingTips} grilling tips`) }
    if (this.filterCounts.pages > 0) { categories.push(`${this.filterCounts.pages} support pages`) }

    const ariaLabel = `Search filters: ${categories.join(', ')}.`

    // If check added here because this ref has only been added on Char-Griller so far
    if (this.$refs.searchFiltersDesktop) {
      this.$refs.searchFiltersDesktop.setAttribute('aria-label', ariaLabel)
    }

    // querySelector - Mobile search filters are outside this component (so this component's this.$refs have it)
    const mobileSearchFilters = document.body.querySelector('[ref="searchFiltersMobile"]')
    // If check added here because this ref has only been added on Char-Griller so far
    if (mobileSearchFilters) {
      mobileSearchFilters.setAttribute('aria-label', ariaLabel)
    }
  }

  sortProductsByPrice (results) {
    return {
      products: results.products.sort((a, b) => {
        return b.price - a.price
      }),
      articles: results.articles,
      pages: results.pages
    }
  }

  onlyGetSupportPages (results) {
    // At the moment there isn't a better way to filter pages, filtering in predictive search is very limited
    const supportPageKeywords = ['warranty', 'register', 'instruction', 'contact', 'faq', 'return', 'privacy', 'terms']
    // If any of the keywords are in the page title, count it as a support page
    return {
      pages: results.pages.filter(page => supportPageKeywords.some(keyword => page.title.toLowerCase().includes(keyword))),
      products: [],
      articles: []
    }
  }

  // Are there any articles that are on a filtered blog type?
  showArticles (results) {
    for (const article of results.articles) {
      for (const [filterKey, handle] of Object.entries(BLOG_HANDLES[this.site])) {
        if (article.url.startsWith(`/blogs/${handle}`) && this.blogFilter[filterKey]) {
          return true
        }
      }
    }

    return false
  }

  async updateSearchResults (queryText, resultsElem, newRequest = true) {
    try {
      // Check user input isn't empty
      if (queryText.length > 0) {
        let resultsDisplayed = []

        // If new query text is different - re-request results
        if (newRequest) {
          this.results.products = this.sortProductsByPrice(await this.getPredictedResults(queryText, { product: true }))
          this.results.articles = await this.getPredictedResults(queryText, { article: true })
          // Only get the articles represented in the predictive search filters
          if (this.results.articles.length > 0) {
            for (const handle of BLOG_HANDLES[this.site]) {
              this.results.articles = this.results.articles.filter(article => article.url.includes(`/blogs/${handle}/`))
            }
          }
          // this.results.pages = this.onlyGetSupportPages(await this.getPredictedResults(queryText, { page: true }))
          this.results.pages = await this.getPredictedResults(queryText, { page: true })
        }

        if (this.resourceTypes.product && this.resourceTypes.article && this.resourceTypes.page) {
          resultsDisplayed = this.results.all = {
            products: this.results.products.products ?? [],
            articles: this.results.articles.articles ?? [],
            pages: this.results.pages.pages ?? []
          }
        } else if (this.resourceTypes.product) {
          resultsDisplayed = this.results.products ?? []
        } else if (this.resourceTypes.article) {
          resultsDisplayed = this.results.articles ?? []
        } else if (this.resourceTypes.page) {
          resultsDisplayed = this.results.pages ?? []
        }

        this.queryText = queryText

        const showProducts = this.resourceTypes.product && resultsDisplayed.products.length > 0
        // Need to check which blog type the articles are on, and if they're on a filtered blog type
        const showArticles = this.showArticles(resultsDisplayed)
        const showPages = this.resourceTypes.page && resultsDisplayed.pages.length > 0

        // If results found for resource type, show them
        if (showProducts || showArticles || showPages) {
          // Results found for type, update HTML..
          const newHTML = this.getResultsHTML(resultsDisplayed)
          resultsElem.innerHTML = newHTML
        } else {
          // No results found on type..
          resultsElem.innerHTML = `<div class="c-header__search-result p-2">
            <div class="flex flex-col p-2">
              <div class="c-header__search-result-title font-bold">No results found</div>
            </div>
          </div>`
        }

        this.updateSearchFilterCounts({
          productResults: this.results.products,
          articleResults: this.results.articles,
          pageResults: this.results.pages
        })
      } else {
        console.warn('updateSearchResults() - No query text')
      }
    } catch (e) {
      switch (e.message) {
        case 'no results':
          resultsElem.innerHTML = `<div class="c-header__search-result p-2">
            <div class="flex flex-col p-2">
              <div class="c-header__search-result-title font-bold">No results found</div>
            </div>
          </div>`
          if (device.isMobile()) {
            document.body.querySelector('[ref="buttonProducts"]').innerText = 'Products'
            document.body.querySelector('[ref="buttonRecipes"]').innerText = 'Recipes and Posts'
          } else {
            document.body.querySelector('[ref="radio-products"] + label').innerText = 'Products'
            document.body.querySelector('[ref="radio-recipes"] + label').innerText = 'Recipes and Posts'
          }
          break
        default:
          console.error('updateSearchResults() - Error:', e)
      }
    }
  }

  showSearchResultsPanel () {
    // Show predictive search results panel
    if (device.isDesktop()) {
      document.querySelector('[ref="predictiveSearchResults"]').classList.remove('hidden')
    } else {
      document.querySelector('[ref="predictiveSearchResultsMobile"]').classList.replace('hidden', 'fixed')
    }
    // Hide main navigation dropdown
    this.closeAllMenus()
  }

  hideSearchResultsPanel () {
    // Hide search results panel
    if (device.isDesktop()) {
      document.querySelector('[ref="predictiveSearchResults"]').classList.add('hidden')
    } else {
      document.querySelector('[ref="predictiveSearchResultsMobile"]').classList.replace('fixed', 'hidden')
    }
    // Hide search input
    this.closeSearchForm()
    this.closeSearchFormMobile()
    // Reset search input
    this.queryText = null
    this.searchInput.value = ''
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-c-header]').forEach(el => new CHeader(el))
})
